if (!window.Eurus.loadedScript.has("newsletter-subscribe.js")) {
  window.Eurus.loadedScript.add("newsletter-subscribe.js");

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xNewsletterSubscribe", (endpointUrl) => ({
        email: "",
        loading: false,
        successMessage: "",
        errorMessage: "",
        submit() {
          if (this.loading) return;
          this.loading = true;
          this.successMessage = "";
          this.errorMessage = "";
          fetch(endpointUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email: this.email }),
          })
            .then((response) => {
              if (response.ok) {
                this.successMessage =
                  "ご登録ありがとうございます。次回のメールレターをお楽しみに。";
                this.email = "";
              } else if (response.status === 429) {
                this.errorMessage =
                  "しばらく時間をおいてから再度お試しください。";
              } else {
                this.errorMessage =
                  "登録に失敗しました。しばらくしてから再度お試しください。";
              }
            })
            .catch(() => {
              this.errorMessage =
                "通信エラーが発生しました。しばらくしてから再度お試しください。";
            })
            .finally(() => {
              this.loading = false;
            });
        },
      }));
    });
  });
}
